import { render, staticRenderFns } from "./LimitConfig.vue?vue&type=template&id=497ac43c"
import script from "./LimitConfig.vue?vue&type=script&lang=js"
export * from "./LimitConfig.vue?vue&type=script&lang=js"
import style0 from "./LimitConfig.vue?vue&type=style&index=0&id=497ac43c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports